/* Translate the gift app's fixed label without changing its checkbox or pricing. */
(() => {
  const target = document.currentScript?.dataset.curlingGiftLabel;
  if (!target) return;
  const known = new Set(['Ajouter un emballage cadeau (offert)', 'Opter pour un emballage cadeau pour cet article (offert)', 'Add complimentary gift wrapping']);
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll('label[for="ptw-gift-needed"]').forEach(label => {
      const text = label.textContent.trim();
      if (text !== target && known.has(text)) label.textContent = target;
    });
  };
  const schedule = () => {
    if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
  };
  update();
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
})();
